import React, { useState } from 'react'
import AnimatedText8 from './AnimatedText8'
import iconorange from '../images/icon_orange.svg';
import shopify from '../images/banner/Shopify_logo_svg.png';
import replo from '../images/banner/replo2.png';


const PriceSection = () => {
    const [handleservice, sethandleservice] = useState(0);

    const reploplanData = [
        {
            title: "Consultation",
            subtitle: "30 Minutes",
            price: "Free",
            oldprice: "$20.00",
            listItem: [
                "Showcase the portfolio",
                "Understanding of Requirements and plan you should go for",
                "The meeting will be for 30 minutes"
            ],
            btnText: "Book Now",
        },
        {
            title: "Basic Plan",
            subtitle: "One Landing Page",
            price: "$299.00",
            oldprice: "$499.00",
            listItem: [
                "8-9 CRO sections",
                "Bundle and subscription functionalities",
                "Code to open the cart drawer",
                "3 rounds of revision",
                "First draft delivers in 5-6 days"
            ],
            btnText: "Get Started",
            extratitle: "Best Value"
        },
        {
            title: "Advance Plan",
            subtitle: "One Landing Page",
            price: "$599.00",
            oldprice: "$799.00",
            listItem: [
                "Thing included in Basic Plan",
                "Advance CRO sections",
                "Codes for Dynamic shipping date displays",
                "Code for randomised purchase",
                "Monster Cart Upsell, Rebuy and post purchase implementation.",
                "First draft delivers in 8-10 days."
            ],
            btnText: "Get Started",
        }
    ]

    const shopifyplanData = [
        {
            title: "Consultation",
            subtitle: "30 Minutes",
            price: "Free",
            oldprice: "$20.00",
            listItem: [
                "Showcase the portfolio",
                "Understanding of Requirements and plan you should go for",
                "The meeting will be for 30 minutes"
            ],
            btnText: "Book Now",
        },
        {
            title: "Basic Plan",
            subtitle: "Enhance your existing store with cutting-edge CRO",
            price: "$1199.00",
            oldprice: "$1499.00",
            listItem: [
                "Revamp the homepage design with CRO-focused sections.",
                "Upgrade the product page with features like a sticky 'Add to Cart' button, trust badges, and Upselling/Cross-Selling tools.",
                "Add a cart drawer with bundle functionality.",
                "Resolve responsiveness issues for a seamless user experience.",
                "Design a single high-converting PDP (Product Detail Page) using CRO best practices."
            ],
            btnText: "Get Started",
            extratitle: "Best Value"
        },
        {
            title: "Advance Plan",
            subtitle: "Build a Shopify store from the ground up with advanced CRO optimization",
            price: "$2499.00",
            oldprice: "$3499.00",
            listItem: [
                "Includes everything from the Basic Plan.",
                "Complete store setup from scratch, including product listings and collection pages.",
                "Design an entire store: Homepage, Product Page, and Collection Page.",
                "Optimize the checkout page (available for Shopify Plus users only).",
                "Install and integrate high-performing CRO apps.",
                "Create three conversion-focused landing pages: Offer, Sales, and Listicle pages."
            ],
            btnText: "Get Started",
        }
    ]

    return (
        <div>
            <section id="service">
                <div className='container-xxl service-container'>

                    <div className='text-box' data-aos="fade-up">
                        <img id="priceimg" className='icon_orange' src={iconorange} alt='icon-orange' />
                        <p>Transparent</p>
                    </div>
                    <AnimatedText8 />

                    <div className='row'>
                        <div className='btnbox'>
                            <div
                                onClick={() => sethandleservice(0)}
                                className={handleservice === 0 ? "btn btn1 activebtn" : "btn btn1"}>
                                <img src={replo} alt='replo' className='img-fluid' />
                            </div>
                            <div
                                onClick={() => sethandleservice(1)}
                                className={handleservice === 1 ? "btn btn2 activebtn" : "btn btn2"}>

                                <img src={shopify} alt='shopify' className='img-fluid' />
                            </div>
                        </div>

                        <div className='container-fluid service-boxes'>

                            {
                                handleservice === 0 ?
                                    <div className='row'>
                                        {/* <div className='col-md-4 col-sm-6 box box1'>
                                <div className='subbox'>
                                    <div className='first'>
                                        <div className='left'>
                                            <h5>Consultation</h5>
                                            <p>30 Minutes</p>
                                        </div>
                                        <div className='right'>
                                            <h4>Free</h4>
                                            <p><del>$20.00</del></p>
                                        </div>
                                    </div>
                                    <hr></hr>
                                    <div className='second'>
                                        <ul>
                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Showcase the portfolio</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Understanding of Requirements and plan you should go for</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>The meeting will be for 30 minutes</p>
                                                    </div>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                    <hr></hr>
                                    <button className='btnservice btns1'>
                                      <a 
                                      href="https://www.upwork.com/freelancers/~0125e50dfd12cf8421" 
                                      target='_blank'
                                      rel="noreferrer" 
                                      >
                                        Book Now</a>
                                    </button>
                                </div>
                            </div>
                            <div className='col-md-4 col-sm-6 box box2'>
                                <div className='subbox'>
                                    <div className='bestbox'>
                                        <p>Best Value</p>
                                    </div>
                                    <div className='first'>
                                        <div className='left'>
                                            <h5>Basic Plan</h5>
                                            <p>One Landing Page</p>
                                        </div>
                                        <div className='right'>
                                            <h4>$100.00</h4>
                                            <p><del>$250.00</del></p>
                                        </div>
                                    </div>
                                    <hr></hr>
                                    <div className='second'>
                                        <ul>

                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>8-9 CRO sections</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Bundle and subscription functionalities</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Code to open the cart drawer</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>3 rounds of  revision</p>
                                                    </div>
                                                </div>
                                            </li>



                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>First draft delivers in 5-6 days</p>
                                                    </div>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                    <hr></hr>
                                    <button className='btnservice btns2'>
                                      
                                        <a 
                                        href="https://www.upwork.com/freelancers/~0125e50dfd12cf8421" 
                                        target='_blank'
                                        rel="noreferrer" 
                                        >
                                        Get Started</a>
                                    </button>

                                </div>
                            </div>
                            <div className='col-md-4 col-sm-6 box box3'>
                                <div className='subbox'>
                                    <div className='first'>
                                        <div className='left'>
                                            <h5>Advance Plan</h5>
                                            <p>One Landing Page</p>
                                        </div>
                                        <div className='right'>
                                            <h4>$200.00</h4>
                                            <p><del>$500.00</del></p>
                                        </div>
                                    </div>
                                    <hr></hr>
                                    <div className='second'>
                                        <ul>

                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Thing included in Basic Plan</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Advance CRO sections</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Codes for Dynamic shipping date displays</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p> Code for randomised purchase</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>Monster Cart Upsell, Rebuy and post purchase implementation.</p>
                                                    </div>
                                                </div>
                                            </li>


                                            <li>
                                                <div className='text-li'>
                                                    <div className='icon'>
                                                        <svg
                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                            stroke-width="0" viewBox="0 0 16 16"
                                                            role="presentation" class="r-1qz24ta"
                                                            height="1.3em" width="1.3em"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                            <path
                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                fill="white"
                                                            ></path>
                                                        </svg>
                                                    </div>
                                                    <div className='txt'>
                                                        <p>First draft delivers in 8-10 days.</p>
                                                    </div>
                                                </div>
                                            </li>


                                        </ul>
                                    </div>
                                    <hr></hr>
                                    <button className='btnservice btns2'>
                                    <a 
                                    href="https://www.upwork.com/freelancers/~0125e50dfd12cf8421" 
                                    target='_blank'
                                    rel="noreferrer" 
                                    >
                                    Get Started</a>
                                    </button>
                                </div>
                            </div> */}
                                        {
                                            reploplanData?.map((data, index) => (
                                                <div className={`col-md-4 col-sm-6 box ${data?.extratitle ? "box2" : "box1"}`} key={index}>
                                                    <div className='subbox'>
                                                        {
                                                            data?.extratitle ?

                                                                <div className='bestbox'>
                                                                    <p>{data?.extratitle}</p>
                                                                </div>

                                                                : ""
                                                        }
                                                        <div className='first'>
                                                            <div className='left'>
                                                                <h5>{data?.title}</h5>
                                                                <p className='subtitletext'>{data?.subtitle}</p>
                                                            </div>
                                                            <div className='right'>
                                                                <h4>{data?.price}</h4>
                                                                <p><del>{data?.oldprice}</del></p>
                                                            </div>
                                                        </div>
                                                        <hr></hr>
                                                        <div className='second'>
                                                            <ul>
                                                                {
                                                                    data?.listItem?.map((list, index) => (
                                                                        <li key={index}>
                                                                            <div className='text-li'>
                                                                                <div className='icon'>
                                                                                    <svg
                                                                                        stroke="#FE7201FF" fill="#FE7201FF"
                                                                                        stroke-width="0" viewBox="0 0 16 16"
                                                                                        role="presentation" class="r-1qz24ta"
                                                                                        height="1.3em" width="1.3em"
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                    >
                                                                                        <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                                                        <path
                                                                                            d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                                            fill="white"
                                                                                        ></path>
                                                                                    </svg>
                                                                                </div>
                                                                                <div className='txt'>
                                                                                    <p>{list}</p>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    ))
                                                                }
                                                            </ul>
                                                        </div>
                                                        <hr></hr>
                                                        <button className='btnservice btns1'>
                                                            <a
                                                                href="https://www.upwork.com/freelancers/~0125e50dfd12cf8421"
                                                                target='_blank'
                                                                rel="noreferrer"
                                                            >
                                                                {data?.btnText}</a>
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div> :
                                    handleservice === 1 ?
                                        <div className='row'>
                                            {
                                                shopifyplanData?.map((data, index) => (
                                                    <div className={`col-md-4 col-sm-6 box ${data?.extratitle ? "box2" : "box1"}`} key={index}>
                                                    <div className='subbox'>
                                                        {
                                                            data?.extratitle ?

                                                                <div className='bestbox'>
                                                                    <p>{data?.extratitle}</p>
                                                                </div>

                                                                : ""
                                                        }
                                                            <div className='first'>
                                                                <div className='left'>
                                                                    <h5>{data?.title}</h5>
                                                                    <p className='subtitletext'>{data?.subtitle}</p>
                                                                </div>
                                                                <div className='right'>
                                                                    <h4>{data?.price}</h4>
                                                                    <p><del>{data?.oldprice}</del></p>
                                                                </div>
                                                            </div>
                                                            <hr></hr>
                                                            <div className='second'>
                                                                <ul>
                                                                    {
                                                                        data?.listItem?.map((list, index) => (
                                                                            <li key={index}>
                                                                                <div className='text-li'>
                                                                                    <div className='icon'>
                                                                                        <svg
                                                                                            stroke="#FE7201FF" fill="#FE7201FF"
                                                                                            stroke-width="0" viewBox="0 0 16 16"
                                                                                            role="presentation" class="r-1qz24ta"
                                                                                            height="1.3em" width="1.3em"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                        >
                                                                                            <circle cx="8" cy="8" r="8" fill="#FE7201FF" />
                                                                                            <path
                                                                                                d="M12.03 4.97a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                                                                                                fill="white"
                                                                                            ></path>
                                                                                        </svg>
                                                                                    </div>
                                                                                    <div className='txt'>
                                                                                        <p>{list}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        ))
                                                                    }
                                                                </ul>
                                                            </div>
                                                            <hr></hr>
                                                            <button className='btnservice btns1'>
                                                                <a
                                                                    href="https://www.upwork.com/freelancers/~0125e50dfd12cf8421"
                                                                    target='_blank'
                                                                    rel="noreferrer"
                                                                >
                                                                    {data?.btnText}</a>
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        : ""
                            }

                        </div>


                    </div>

                </div>
            </section>
        </div>
    )
}

export default PriceSection